import { render, staticRenderFns } from "./CompSpeechBubble.vue?vue&type=template&id=7ac829ec"
import script from "./CompSpeechBubble.vue?vue&type=script&lang=js"
export * from "./CompSpeechBubble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports